








































































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { isLogin, getImagePath } from "@/utils/utils";
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import { NewsApi } from "@/api/newsApi";
import { message } from "ant-design-vue";
import { CommonApi } from "@/api/commonApi";

@Component({
  components: {
    Header,
    Footer,
  },
})
export default class NewsDetail extends Vue {
  newsApi: NewsApi;
  commonApi: CommonApi;
  id: number;
  info = {};
  weekHots: Array<object> = [];
  monthHots: Array<object> = [];
  latelyNews: Array<object> = [];
  customerName: string | null = "";
  customerAva: string | null =
    process.env.VUE_APP_IMG_HOST + "/Images/userAva.png";
  isLogin = false;
  wxLoginUrl = `https://open.weixin.qq.com/connect/qrconnect?appid=wxda87ecd6150c5b3d&redirect_uri=${encodeURIComponent(
    process.env.VUE_APP_HOST_URL
  )}&response_type=code&scope=snsapi_login&state=STATE`;
  commentStr = "";
  parentId = 0;
  commentList: Array<object> = [];
  adInfo = {};
  refNews: Array<any> = [];
  refImageText: Array<any> = [];
  refDic: Array<any> = [];
  refVideo: Array<any> = [];
  refBook: Array<any> = [];
  comments: Array<any> = [];

  constructor() {
    super();
    this.newsApi = new NewsApi();
    this.commonApi = new CommonApi();
    this.id = Number(this.$route.query["id"]);
  }
  mounted() {
    this.initData();
    this.isLogin = isLogin();
    if (this.isLogin) {
      this.customerName = sessionStorage.getItem("nickName");
      this.customerAva = getImagePath(sessionStorage.getItem("avaUrl"));
    }
  }

  @Watch("$route")
  getRoute(newVal: any, oldVal: any) {
    if (newVal !== oldVal) {
      this.id = Number(newVal.query.id);
      this.initData();
    }
  }

  initData() {
    this.getNewsInfo();
    this.getLeftData();
    this.getAdInfo();
    this.getExtInfo();
  }

  getExtInfo() {
    this.newsApi.getExtInfo(this.id).then((res) => {
      this.refNews = res.data.refNews;
      this.refImageText = res.data.refImageText;
      this.refDic = res.data.refDic;
      this.refVideo = res.data.refVideo;
      this.refBook = res.data.refBook;
    });
  }

  getAdInfo() {
    this.commonApi.getAdInfo(3).then((res) => {
      this.adInfo = res.data;
    });
  }

  getNewsInfo() {
    this.newsApi.getNewsInfo(this.id).then((res) => {
      this.info = res.data.contentDetail;
      this.commentList = res.data.commentList;
    });
  }

  getLeftData() {
    this.newsApi.getHotsData().then((res) => {
      this.weekHots = res.data.weekHots;
      this.monthHots = res.data.monthHots;
      this.latelyNews = res.data.latelyNews;
    });
  }

  comment() {
    if (this.commentStr.trim().length > 0) {
      this.newsApi
        .comment(this.id, this.commentStr, this.parentId)
        .then((res) => {
          message.success("评论成功");
          const item: any = {};
          item.Comment = res.data.Comment;
          item.CreateTime = res.data.CreateTime;
          item.CustomerAva = sessionStorage.getItem("avaUrl");
          item.ID = res.data.ID;
          item.NickName = sessionStorage.getItem("nickName");
          this.commentList.splice(0, 0, item);
          this.commentStr = "";
        });
    } else {
      message.warn("请先输入评论内容");
    }
  }
}
